export const FETCH_PROVINCE_TYPES_REQUEST = 'FETCH_PROVINCE_TYPES_REQUEST';
export const FETCH_PROVINCE_TYPES_SUCCESS = 'FETCH_PROVINCE_TYPES_SUCCESS';
export const FETCH_PROVINCE_TYPES_FAILURE = 'FETCH_PROVINCE_TYPES_FAILURE';